module.exports = __webpack_public_path__ + "media/mosaics/Mosaics-Room-LivingRoom-0ade2524.jpg";